<script>
  import { post } from "../utils/api";

  import { getToken, setToken } from "../utils/token";

  let email;

  let divErrorEmail;
  let errorMsg = "";
  let okMsg = "";

  let send = e => {
    const error = divErrorEmail.classList.contains("has-error");
    if (!error) {
      e.preventDefault();
      post("ResetPassword", { email }, "json");
      okMsg =
        "Accede a tu correo electrónico para obtener tu nueva contraseña.";
    }
  };

  let onload = async () => {
    if (getToken() !== "") {
      const response = await post("RolUsuario", { token: getToken() }, "json");
      if (response.editor || response.editorJefe) {
        location.href = "/articulos-editor";
      } else {
        if (response.revisor) {
          location.href = "/articulos-revisor";
        } else {
          location.href = "/articulos-autor";
        }
      }
    }
  };

  onload();
</script>

<div class="ie-panel">
  <a href="http://windows.microsoft.com/en-US/internet-explorer/">
    <img
      src="images/ie8-panel/warning_bar_0000_us.jpg"
      height="42"
      width="820"
      alt="You are using an outdated browser. For a faster, safer browsing
      experience, upgrade for free today." />
  </a>
</div>
<div class="preloader" id="loading">
  <div class="preloader-body">
    <div id="loading-center-object">
      <div class="object" id="object_four" />
      <div class="object" id="object_three" />
      <div class="object" id="object_two" />
      <div class="object" id="object_one" />
    </div>
  </div>
</div>
<div class="page">
  <section class="section section-layout-3-outer">
    <div class="section-layout-3">
      <div class="layout-2 section-layout-3-header">
        <div class="layout-2-inner">
          <div class="layout-2-item" />
          <div class="layout-2-item">
            <div class="layout-2-group">
              <p class="text-gray-900 ls-001">¿No tienes una cuenta?</p>
              <a
                class="button button-sm button-primary-outline"
                href="register">
                Registro
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="section-layout-3-main">
        <div class="section-1 text-center">
          <div class="container">
            <div class="box-shadow-1">
              <a class="brand" href="/">
                <img
                  class="brand-logo-dark"
                  src="images/revista/logo.png"
                  alt="Logo" />
              </a>
              {#if okMsg !== ''}
                <div class="alert alert-success registerOk" role="alert">
                  {okMsg}
                  <a class="link link-icon link-icon-left" href="login">
                    <span class="icon mdi mdi-arrow-left" />
                    <span>Volver</span>
                  </a>
                </div>
              {:else}
                <p class="text-gray-900">
                  <span style="max-width: 400px">
                    Introduce tu e-mail para reestablecer tu contraseña.
                  </span>
                </p>
                <div class="box-shadow-1-main">
                  <!-- RD Mailform-->
                  <form class="rd-form rd-mailform" on:submit={e => send(e)}>

                    {#if errorMsg !== ''}
                      <div class="alert alert-danger" role="alert">
                        {errorMsg}
                      </div>
                    {/if}

                    <div class="form-wrap" bind:this={divErrorEmail}>
                      <input
                        class="form-input"
                        id="login-email"
                        type="email"
                        name="email"
                        placeholder="E-mail"
                        data-constraints="@Email @Required"
                        bind:value={email} />
                    </div>
                    <div class="form-wrap">
                      <button
                        class="button button-block button-primary button-shadow"
                        type="submit">
                        Enviar
                      </button>
                    </div>
                  </form>
                </div>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<div class="snackbars" id="form-output-global" />
